module.exports = __webpack_public_path__ + "static/img/教师职工.65b54bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/教师职工.jpg
// module id = 0iIY
// module chunks = 0